import $ from 'jquery';
import {dependency} from '../../utils/request';
import {frame} from '../../utils/drawing';
import {directiveSettings} from '../../utils/parse';
import {onResize} from '../../utils/window';

/**
 * The CDN directory of the Swiper library.
 *
 * @see http://idangero.us/swiper
 * @type {string}
 */
const swiperDir = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.3.8/';

let addedCss = false;

/**
 * Initializes a Swiper carousel.
 *
 * @see http://idangero.us/swiper
 * @param context
 */
export default function swiperDirective(context = document.body) {
  const $context = $(context);
  const $swipers = $context.find('[sw-swiper]');
  const $projects = $context.find('[sw-projects]');

  const hasSwiper = $swipers.length > 0;
  const hasProjects = $projects.length > 0;
  if (hasSwiper || hasProjects) {

    if (!addedCss) {
      addedCss = true;
      $('head').
          append(
              `<link rel="stylesheet" href="${swiperDir}css/swiper.min.css">`);
    }

    dependency(swiperDir + 'js/swiper.min.js', () => window.Swiper).
        then(function() {
          if (hasSwiper) {
            createDefaultSwiper($swipers);

            // const galleries = $('.slideshow-gallery');
            // if (galleries.length) {
            //   galleryHeightModifier(galleries);
            // }
          }

          if (hasProjects) {
            createProjectSwipers($projects);
          }
        });
  }
}

function createDefaultSwiper($swipers) {
  $swipers.each(function() {
    const $element = $(this);
    const json = $element.attr('sw-swiper');
    const $parent = $element.parents('.timeline');
    let currentStage = null;

    if ($parent.length) {

      const $pSlides = $element.find('.slideshow_slide');
      currentStage = parseInt($('[sw-timeline]').first().attr('sw-timeline'));

      // get the stage off the module if its there
      let module = $element.closest('.-type-timelineModule');
      if (module) {
        let stage = parseInt(module.data('stage'))
        if (stage) currentStage = stage;
      }

      if (currentStage > $pSlides.length) currentStage = $pSlides.length;
      if (currentStage < 1) currentStage = 1;

      $($pSlides[currentStage-1]).find('.timeline-item_current').removeClass('\+hidden');
    }

    const settings = directiveSettings(json, {
      loop: true,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
      },
      pagination: {
        type: 'button',
        clickable: true,
      },
      runCallbacksOnInit: true,
    });

    settings.pagination['renderBullet'] = function(index, className) {
      let i = index + 1;
      if (i < 10) {
        i = '0' + i;
      }
      return '<span class="' + className + '">' + (i) + '</span>';
    };

    if (currentStage !== null) {
      settings['initialSlide'] = currentStage - 1;
    }

    const $slides = $element.find('.swiper-slide');
    const swiper = $slides.length > 1 ? new Swiper(this, settings) : false;

    if (swiper && settings.slidesPerView === 'auto') {
      swiper.snapGrid = [...swiper.slidesGrid];
    }
    frame(() => $element.addClass('swiper-ready'));
  });
}

function createProjectSwipers($projects) {
  $projects.each(function() {
    const _this = $(this);

    const bgEl = _this.find('[sw-projects-bg]');
    const contentEl = _this.find('[sw-projects-main]');

    const bgSwiper = setupProjectSwiper(bgEl, bgEl.attr('sw-projects-bg'));
    const mainSwiper = setupProjectSwiper(contentEl,
        contentEl.attr('sw-projects-main'));

    const line = $('.our-projects-nav_line');

    bgSwiper.controller.control = mainSwiper;
    mainSwiper.controller.control = bgSwiper;

    // const navItems = $('.our-projects-nav_item');
    //
    // line.css('width', navItems.first().outerWidth() + 'px');
    //
    // mainSwiper.on('slideChangeTransitionStart', function () {
    //   line.css('transform', `translateX(${this.activeIndex * line.width()}px)`);
    //
    //   navItems.removeClass('-active');
    //   $(`.our-projects-nav_item[data-index=${this.activeIndex}]`).addClass('-active');
    // });
    //
    // navItems.click(function () {
    //   const _this = $(this);
    //   const index = _this.attr('data-index');
    //
    //   navItems.removeClass('-active');
    //   _this.addClass('-active');
    //
    //   line.css('transform', `translateX(${parseInt(index) * line.width()}px)`);
    //   mainSwiper.slideTo(index);
    // });
  });
}

function setupProjectSwiper(el, json) {
  let settings = directiveSettings(json, {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
    pagination: {
      type: 'button',
      clickable: true,
    },
    runCallbacksOnInit: true,
  });

  settings.pagination['renderBullet'] = function(index, className) {
    let i = index + 1;
    if (i < 10) {
      i = '0' + i;
    }
    return '<span class="' + className + '">' + (i) + '</span>';
  };

  return new Swiper(el[0], settings);
}

// function galleryHeightModifier(galleries) {
//   galleries.each(function(index, el) {
//     console.log(el);
//     onResize(function() {
//
//     });
//   });
// }



// WEBPACK FOOTER //
// ./source/scripts/directives/media/swiper.js